module.exports = __webpack_public_path__ + "static/media/newError404.89f642b3.png";